import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IntegrationService } from './integration.service';

@Injectable()
export class ArticleLibraryService {

  constructor(
    private http: HttpClient,
    private _integrationService: IntegrationService
  ) { }

  getKnowledgeRepoType(){
    if(this._integrationService.oracleEnabled){
      return 'oracle/'
    }else if(this._integrationService.sharepointEnabled){
      return 'sharepoint/'
    }
  }


  getArticleList(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/list_article')
  }

  deleteArticle(agentId, articleId) {
    return this.http.delete(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/delete_article/' + articleId)
  }

  ingestDoc(agentId, articleId, params) {
    return this.http.post(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/' + articleId + '/ingest_draft', params)
  }

  getIngetionHistory(agentId) {
    return this.http.get(environment.knowledge_repo_service + 'knowledge_repository/' + this.getKnowledgeRepoType() + agentId + '/ingestion_history')
  }



}
